import { Component, ComponentFactoryResolver, OnInit, ViewChild } from "@angular/core";
import { HeroDirective } from "../hero.directive";
import { HeroService } from "@app/home/hero/hero.service";
import { ComponentType } from "@app/component-type";

@Component({
  selector: "om-hero",
  templateUrl: "./hero.component.html",
  styleUrls: ["./hero.component.scss"],
})
export class HeroComponent implements OnInit {
  @ViewChild(HeroDirective) heroHost: HeroDirective;

  constructor(
    private componentFactoryResolver: ComponentFactoryResolver,
    private heroService: HeroService
  ) {}

  ngOnInit() {
    this.loadHero();
  }

  loadHero() {
    const viewContainerRef = this.heroHost.viewContainerRef;
    viewContainerRef.clear();

    const hero: ComponentType = this.heroService.getHero();
    const componentFactory = this.componentFactoryResolver.resolveComponentFactory(hero);
    viewContainerRef.createComponent(componentFactory);
  }
}
